import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from "@mui/material";
import React from "react";

const DetailCard = ({ policy, approvedBy, policyOwner }) => {
  return (
    <Card sx={{ marginBottom: 2, borderRadius: " 12px" }} variant="outlined">
      <CardHeader
        title="Details"
        sx={{
          borderBottom: "1px solid #ddd",
          background: "#F7F7FC",
          ".MuiCardHeader-title": {
            fontSize: "18px",
          },
          padding: "14px",
        }}
      />
      <CardContent
        sx={{ display: "flex", flexDirection: "column", gap: "16px" }}
      >
        <Box display="flex" alignItems="center">
          <Typography flexBasis="30%" color="#585555">
            Type:
          </Typography>
          <Typography fontWeight="bold">
            {policy?.category?.charAt(0)?.toUpperCase() +
              policy?.category?.slice(1)}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center">
          <Typography flexBasis="30%" color="#585555">
            Managed on:
          </Typography>
          <Typography fontWeight="bold">Regodit</Typography>
        </Box>
        <Box display="flex" alignItems="center">
          <Typography flexBasis="30%" color="#585555">
            Approved by:
          </Typography>
          <Box
            sx={{ display: "flex", alignItems: "center", gap: "4px" }}
            fontWeight="bold"
          >
            {approvedBy && (
              <Avatar
                sx={{
                  width: 32,
                  height: 32,
                  fontSize: "10px",
                  bgcolor: "#C9DFF9",
                }}
              >
                {approvedBy?.name
                  ?.split(" ")
                  .map((word, index) => {
                    if (
                      index === 0 ||
                      index === approvedBy?.name.split(" ").length - 1
                    ) {
                      return word.charAt(0);
                    }
                    return null;
                  })
                  .join("")}
              </Avatar>
            )}
            <Typography>
              {approvedBy ? approvedBy?.name : "Not approved yet"}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" alignItems="center">
          <Typography flexBasis="30%" color="#585555">
            Uploaded by:
          </Typography>
          <Box
            sx={{ display: "flex", alignItems: "center", gap: "4px" }}
            fontWeight="bold"
          >
            <Avatar
              sx={{
                width: 32,
                height: 32,
                fontSize: "10px",
                bgcolor: "#A9B5FF",
              }}
            >
              {policyOwner?.name
                ?.split(" ")
                .map((word, index) => {
                  if (
                    index === 0 ||
                    index === policyOwner?.name.split(" ").length - 1
                  ) {
                    return word.charAt(0);
                  }
                  return null;
                })
                .join("")}
            </Avatar>
            <Typography>
              {policyOwner?.name || policy?.owner?.role_name}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default DetailCard;
